import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import usePermissions from "../hook/usePermissions";
import {
  getRequiredPermissionForPath,
  getFirstPermittedRoute,
} from "./PermissionHelper";

const PrivateRoute = () => {
  const token = localStorage.getItem("userToken");
  const location = useLocation();
  const { hasPermission, loading } = usePermissions();

  if (!token) {
    return <Navigate to="/sign-in" replace />;
  }

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center vh-100 bg-white">
        <div className="spinner-border text-primary-600" role="status">
          <span className="visually-hidden">Loading permissions...</span>
        </div>
      </div>
    );
  }

  const required = getRequiredPermissionForPath(location.pathname);

  // If visiting Dashboard '/' but user does NOT have Dashboard permission
  if (location.pathname === "/" && !hasPermission("Dashboard", "view")) {
    const firstAllowed = getFirstPermittedRoute(hasPermission);
    if (firstAllowed !== "/") {
      return <Navigate to={firstAllowed} replace />;
    }
  }

  if (required && !hasPermission(required.module, required.action)) {
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
